module.exports = ".footer-btn {\n  flex: 1; }\n\n.summary-container {\n  width: calc(100% - 40px);\n  margin: 0 auto; }\n"